export enum CompanyType {
  REGULAR = "REGULAR",
  LIMITED_FEATURES_FLEXPSP = "LIMITED_FEATURES_FLEXPSP",
  PORTAL_GATEWAY = "PORTAL_GATEWAY",
  FEE_REGULAR = "FEE_REGULAR",
  FEE_CURRENCY_CLOUD = "FEE_CURRENCY_CLOUD",
  WHITE_LABEL = "WHITE_LABEL",
}
